module.exports = {"id":"200113","name":"Florian Jozefzoon","rating":"71","photo":"./data/images/photos/1/200113.png","club":{"name":"Brentford","logo":"./data/images/clubs/Brentford.png"},"positions":["AG","AD","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlorianJozefzoon0.json
// module id = 1449
// module chunks = 0